import { ListLocationModel } from "client/Api/Documents/SharePoint/common";
import * as fileDownloader from "client_legacy/ndaw/fileDownloader";
import { environmentHttpClient } from "client/Api/httpClient";
import { urlEncodeObject } from "client_legacy/ndaw/urlHelper";
import { createUrlRelativeToEnvironment } from "client_legacy/ndaw/navigator";

export type DocumentItemVersion = {
	id: number | null;
	label: string;
	creationDate: Date;
	createdBy: string | null;
	path: string;
	isCurrentVersion: boolean;
};

export type VersionLocationModel = {
	fileId: number;
	location: ListLocationModel;
};

export type RequestModel = {
	fileId: number;
	location: ListLocationModel;
	id: number;
};

export function get(
	model: VersionLocationModel,
	signal?: AbortSignal
): Promise<readonly DocumentItemVersion[]> {
	return environmentHttpClient.get<readonly DocumentItemVersion[]>(
		"Documents/SharePoint/Version/GetVersions",
		model,
		{ signal }
	);
}

export function restore(
	model: RequestModel,
	signal?: AbortSignal
): Promise<void> {
	const params: string = urlEncodeObject({
		fileId: model.fileId,
		location: model.location,
		id: model.id
	});

	return environmentHttpClient.post<void>(
		`Documents/SharePoint/Version/RestoreVersion?${params}`,
		undefined,
		{ signal }
	);
}

export function deleteVersion(
	model: RequestModel,
	signal?: AbortSignal
): Promise<void> {
	const params: string = urlEncodeObject({
		fileId: model.fileId,
		location: model.location,
		id: model.id
	});

	return environmentHttpClient.post<void>(
		`Documents/SharePoint/Version/DeleteVersion?${params}`,
		undefined,
		{ signal }
	);
}

export function download(model: RequestModel): void {
	const params: string = urlEncodeObject({
		fileId: model.fileId,
		location: model.location,
		id: model.id
	});

	const downloadUrl: string = `Documents/SharePoint/Version/DownloadVersion?${params}`;
	const url: string = createUrlRelativeToEnvironment(downloadUrl);
	fileDownloader.download(url);
}
